(function () {
  if (typeof document === 'undefined') return;

  var roots = Array.prototype.slice.call(document.querySelectorAll('.hero-tabs'));
  if (!roots.length) return;
  try { console.log('[hero-tabs] init:', roots.length); } catch (e) {}

  roots.forEach(function (root) {
    var container = root.parentElement || root; // parent holds both tabs and panels
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.js-hero-tab'));
    if (!buttons.length) return;
    try { console.log('[hero-tabs] buttons:', buttons.length); } catch (e) {}

    function setActiveButton(targetBtn) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn === targetBtn);
      });
    }

    // Optional: panel control if data attributes are provided later
    function activateByName(name) {
      // Toggle buttons
      buttons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-tab') === name;
        btn.classList.toggle('is-active', isActive);
      });

      // Toggle panels if present
      var panels = Array.prototype.slice.call(container.querySelectorAll('.hero-tab-panel'));
      if (!panels.length) return;
      panels.forEach(function (panel) {
        var show = panel.getAttribute('data-panel') === name;
        if (show) {
          panel.classList.remove('hidden');
        } else {
          panel.classList.add('hidden');
        }
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var name = btn.getAttribute('data-tab');
        if (name) {
          activateByName(name);
        } else {
          setActiveButton(btn);
        }
      });
    });

    // If one button is pre-marked active in markup, honor it; otherwise default to first
    var preActive = buttons.find(function (b) { return b.classList.contains('is-active'); });
    if (preActive) {
      var preName = preActive.getAttribute('data-tab');
      if (preName) {
        activateByName(preName);
      } else {
        setActiveButton(preActive);
      }
    } else if (buttons[0]) {
      var firstName = buttons[0].getAttribute('data-tab');
      if (firstName) {
        activateByName(firstName);
      } else {
        setActiveButton(buttons[0]);
      }
    }
  });
})();
